import { render, staticRenderFns } from "./WorkloadList.vue?vue&type=template&id=08728d2c&scoped=true"
import script from "./WorkloadList.vue?vue&type=script&lang=js"
export * from "./WorkloadList.vue?vue&type=script&lang=js"
import style0 from "./WorkloadList.vue?vue&type=style&index=0&id=08728d2c&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "08728d2c",
  null
  
)

export default component.exports